// Core Angular
import './Team.scss';
import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import { AccountFeatures } from 'modules/account/AccountFeatures';
import { TenantFeatures } from 'modules/application/tenant/TenantFeatures';
import { Contexts } from 'modules/core/ContextProcessorService';
import { Permission } from 'modules/shared/applicationTeam/ApplicationTeamService';
// Modal
import { ConfirmationModal } from 'modules/ui';
import addUserView from './addUserModal/addUserView.html';
import addUserController from './addUserModal/addUserController';
export class TeamController {
    static $inject = ['ngToast', 'ModalService', 'LoadingService', 'application', 'AuthenticationService', '$translate', '$scope', '$window', '$state', 'ApplicationService2', 'ApplicationTeamService', 'AccountService2', 'TeamSegmentService', 'BLIP_DOMAIN', 'ContextProcessorService', 'TenantService', 'PaginationService'];
    constructor(ngToast, ModalService, LoadingService, application, AuthenticationService, $translate, $scope, $window, $state, ApplicationService2, ApplicationTeamService, AccountService2, TeamSegmentService, BLIP_DOMAIN, ContextProcessorService, TenantService, PaginationService) {
        'ngInject';
        this.ModalService = ModalService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$window = $window;
        this.$state = $state;
        this.ApplicationService2 = ApplicationService2;
        this.ApplicationTeamService = ApplicationTeamService;
        this.AccountService2 = AccountService2;
        this.TeamSegmentService = TeamSegmentService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.PaginationService = PaginationService;
        this.fetchAll = false;
        this.orderByUserIdentity = false;
        this.isRefreshing = false;
        this.isSkipPage = false;
        this.membersBuffer = [];
        this.isQueryingMembers = false;
        this.onChangePage = async (event) => {
            const value = event.detail;
            if (value) {
                this.isSkipPage = true;
                this.PaginationService.changePage(value);
                await this.updatePaginationData();
            }
        };
        this.onChangeItemsPerPage = async (event) => {
            const itemsPerPage = event.detail;
            if (itemsPerPage) {
                this.PaginationService.changeItemsPerPage(itemsPerPage);
                await this.updatePaginationData();
            }
        };
        this.handleFilterChange = (event) => {
            const searchText = event.target.value;
            if (searchText.length === 0) {
                this.isQueryingMembers = false;
                this.searchResults = '';
                this.users = this.membersBuffer;
                this.$scope.$applyAsync();
            }
            this._executeFilter(searchText);
        };
        this.ngToast = ngToast;
        this.application = application;
        this.isAdding = false;
        this.AuthenticationService = AuthenticationService;
        this.$translate = $translate;
        this.users = [];
        this.isQueryingMembers = false;
        if (this.isNewTeamMembers) {
            this.PaginationService.initialize();
        }
    }
    async $onInit() {
        this.LoadingService.startLoading(false);
        this.isNewTeamMembers = await TenantFeatures.newTeamMembers();
        await this.checkFeatures();
        this.TeamSegmentService.setApplication(this.application);
        this.TeamSegmentService.trackOpened();
        await this._loadUsers();
    }
    async checkFeatures() {
        this.isBlipAccountEnabled = await AccountFeatures.isBlipAccountEnabled();
    }
    async addUser() {
        const modal = await this.ModalService.showModal({
            template: addUserView,
            controller: addUserController,
            controllerAs: '$ctrl',
        });
        const data = await modal.close;
        if (!data) {
            return;
        }
        const { user, permissionCode } = data;
        if (!user) {
            return;
        }
        user.permissions = user.permissions || [];
        if (user.email === this.AuthenticationService.email) {
            const errorMsg82 = await this.$translate('utils.errorMsg.82');
            this.ngToast.danger(errorMsg82);
            return;
        }
        const permissionsFile = angular.copy(permissions);
        const permissionAction = Math.min(permissionCode, 3);
        if (permissionAction) {
            if (permissionCode === 4) {
                user.permissions = [
                    ...user.permissions,
                    {
                        ...permissionsFile.team,
                        permissionAction,
                    },
                ];
            }
            user.permissions = [
                ...user.permissions,
                ...Object.keys(permissionsFile)
                    .filter(p => p && p !== 'team' &&
                    (!permissionsFile[p].hideInTemplate || !permissionsFile[p].hideInTemplate.includes(this.application.template)))
                    .map((p) => ({
                    ...permissionsFile[p],
                    permissionAction,
                })),
            ];
        }
        this.confirmAddUser(user);
    }
    cancelAddUser() {
        this.isAdding = false;
        this.users.shift();
    }
    async confirmAddUser(user) {
        const toastMessage = this.users.find((u) => u.email === user.email)
            ? await this.$translate('utils.successMsg.34')
            : user.isPending
                ? await this.$translate('modules.application.detail.team.sentEmail')
                : await this.$translate('utils.successMsg.7');
        const applicationUrl = `${window.location.origin}/application/detail/${this.application.shortName}/home`;
        await this._callWithLoading(async () => {
            const loggedUser = this.AuthenticationService.getAccount();
            const newUser = {
                shortName: this.application.shortName,
                applicationName: this.application.name,
                userEmail: user.email,
                userFullName: user.email,
                userCulture: loggedUser.culture,
                returnUrl: applicationUrl,
                permissions: user.permissions
                    .map((p) => ({
                    permissionClaim: p.claim,
                    permissionAction: p.permissionAction,
                    id: p.id,
                })),
            };
            const userIdentity = `${encodeURIComponent(user.email)}@${this.BLIP_DOMAIN}`;
            if (!await this.TenantService.isEmailOnTenant(userIdentity)) {
                try {
                    const emails = [user.email];
                    await this.TenantService.inviteMany(emails, this.ContextProcessorService.tenant.id, this.TenantService.guest);
                }
                catch (error) {
                    console.error(error);
                }
            }
            const tenantId = this.ContextProcessorService.context === Contexts.Tenants
                ? this.ContextProcessorService.tenant.id
                : undefined;
            await this.ApplicationTeamService.setApplicationUser(this.application.shortName, newUser.userEmail, tenantId);
            const identityUser = `${encodeURIComponent(newUser.userEmail)}@${this.BLIP_DOMAIN}`;
            const irisPermissions = newUser.permissions.map(p => Permission.fromMessagingHubPermission(p, identityUser));
            await this.ApplicationTeamService.setApplicationPermissions(this.application.shortName, irisPermissions);
            this.trackMemberInvited(newUser.userEmail);
            this.isAdding = false;
            this.membersBuffer = await this._loadMembers();
            await this._loadUsers();
        }, toastMessage);
    }
    async deleteUser(event, email) {
        event.stopPropagation();
        const userCannotRemoved = await this.$translate('modules.application.detail.team.userCannotRemoved');
        const modalTitle = await this.$translate('modules.application.detail.team.confirmExclusion');
        const modalBody = await this.$translate('modules.application.detail.team.modalBody', { email: email });
        const yes = await this.$translate('utils.misc.yes');
        const no = await this.$translate('utils.misc.no');
        const invitedRemoved = await this.$translate('modules.application.detail.team.invitedRemoved');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (!confirmation) {
            return;
        }
        await this._callWithLoading(async () => {
            await this.ApplicationTeamService.deleteApplicationUser(this.application.shortName, email);
            this.users = this.membersBuffer.filter((u) => u.email !== email);
        }, invitedRemoved);
        this.trackMemberDeleted(email);
        this.membersBuffer = await this._loadMembers();
        await this._loadUsers();
        if (this.isNewTeamMembers) {
            await this.updatePaginationData();
        }
    }
    async _loadUsers() {
        await this._callWithLoading(async () => {
            if (this.membersBuffer.length === 0) {
                this.membersBuffer = await this._loadMembers();
            }
            const applicationUsersPermissions = await this.ApplicationService2.getApplicationUsersPermissions(this.application);
            this.users = this.membersBuffer.map(u => {
                const userPermissions = applicationUsersPermissions.filter(p => u.user?.identity &&
                    p.userIdentity.toUpperCase() === u.user.identity.toUpperCase());
                const permissions = this.ApplicationTeamService
                    .convertIrisPermissionsToMessagingHub(userPermissions);
                return {
                    ...u,
                    irisPermissions: userPermissions,
                    permissions,
                };
            });
            this.users = this.users.map(u => {
                const identityEmail = decodeURIComponent(u.user?.identity?.replace(`@${this.BLIP_DOMAIN}`, ''));
                return {
                    email: u.user.email || identityEmail,
                    permissions: this._mapApiPermissions(u.permissions),
                    owner: u.user.email === this.AuthenticationService.email,
                    isAdmin: this._mapApiPermissions(u.permissions).some(p => p.claim === 112 && p.permissionAction > 0),
                    isPending: u.user.isPending,
                    created: new Date(u.created),
                    fullName: u.user.fullName || identityEmail,
                    photoUri: u.user.photoUri,
                    irisPermissions: u.irisPermissions,
                };
            });
            this.membersBuffer = this.users;
            if (this.isNewTeamMembers) {
                await this.updatePaginationData();
            }
            if (this.isBlipAccountEnabled) {
                await this.fillUserInformation();
            }
        });
    }
    async _loadMembers() {
        return await this.ApplicationService2.getUsersAccounts(this.application, this.isNewTeamMembers ? 0 : this.PaginationService.skip, this.isNewTeamMembers ? this.PaginationService.itemsPerPage : 1000, this.isNewTeamMembers ? this.orderByUserIdentity = true : this.orderByUserIdentity, this.isNewTeamMembers ? this.fetchAll = true : this.fetchAll);
    }
    async updatePaginationData() {
        const items = this.isQueryingMembers ? this.searchResults : this.membersBuffer;
        this.PaginationService.calculatePagination(items);
        this.users = this.PaginationService.getCurrentPageItems(items, this.isSkipPage);
        this.isSkipPage = false;
    }
    async fillUserInformation() {
        const promises = [];
        for (const user of this.users) {
            const userIdentifier = encodeURIComponent(encodeURIComponent(user.email));
            const promise = this.AccountService2.get(userIdentifier)
                .then((resource) => {
                user.fullName = resource.fullName;
            })
                .catch((e) => {
                user.fullName =
                    user.fullName || user.email.split('@')[0];
            });
            promises.push(promise);
        }
        await Promise.all(promises);
    }
    async _callWithLoading(call, successMessage) {
        this.LoadingService.startLoading();
        try {
            await call();
            if (successMessage) {
                this.ngToast.success(successMessage);
            }
        }
        catch (err) {
            console.error(err);
            const errorMsg66 = await this.$translate('utils.errorMsg.66');
            this.ngToast.danger(errorMsg66);
            throw err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    _mapApiPermissions(userPermissions) {
        return Object.keys(permissions).map((p) => {
            let permissionAction;
            if (userPermissions.find((u) => u.permissionClaim == permissions[p].claim) != undefined) {
                permissionAction = userPermissions.find((u) => u.permissionClaim == permissions[p].claim).permissionAction;
            }
            else if (permissions[p].parent != undefined && permissions[permissions[p].parent] != undefined) {
                const parentClaim = permissions[permissions[p].parent].claim;
                permissionAction = userPermissions.find((u) => u.permissionClaim == parentClaim)?.permissionAction || 0;
            }
            else {
                permissionAction = 0;
            }
            return {
                enabled: userPermissions.some((up) => up.permissionClaim == permissions[p].claim),
                permissionAction: permissionAction,
                ...permissions[p],
            };
        });
    }
    editUser(user) {
        if (!user.owner) {
            this.trackMemberOpened(user.email);
            this.$state.go('auth.application.detail.team.edit', {
                userData: user,
            });
        }
    }
    async _executeFilter(searchText) {
        this.LoadingService.startLoading();
        this.isQueryingMembers = true;
        this.noSearchResults = false;
        const normalizedSearch = searchText?.toLowerCase() ?? '';
        if (normalizedSearch.length > 2) {
            this.searchResults = this.membersBuffer.filter((user) => {
                const userName = user.fullName?.toLowerCase() || '';
                const userEmail = user.email?.toLowerCase() || '';
                return userName.includes(normalizedSearch) || userEmail.includes(normalizedSearch);
            });
            this.noSearchResults = this.searchResults.length === 0;
            if (this.isNewTeamMembers) {
                await this.updatePaginationData();
            }
            else {
                if (this.searchResults.length > 0) {
                    this.users = this.searchResults;
                    this.$scope.$applyAsync();
                }
                else {
                    this.users = [];
                    this.searchResults = '';
                    this.$scope.$applyAsync();
                    this.isQueryingMembers = false;
                }
            }
        }
        this.LoadingService.stopLoading();
    }
    searchBlur() {
        if (this.searchUsed) {
            this.trackMemberSearched();
        }
        this.searchUsed = false;
    }
    trackMemberSearched() {
        this.TeamSegmentService.trackMemberSearched();
    }
    trackMemberOpened(id) {
        this.TeamSegmentService.trackMemberOpened({ ID: id });
    }
    trackMemberInvited(id) {
        this.TeamSegmentService.trackMemberInvited({ ID: id });
    }
    trackMemberDeleted(id) {
        this.TeamSegmentService.trackMemeberDeleted({ ID: id });
    }
}
TeamController.$inject = ['ngToast', 'ModalService', 'LoadingService', 'application', 'AuthenticationService', '$translate', '$scope', '$window', '$state', 'ApplicationService2', 'ApplicationTeamService', 'AccountService2', 'TeamSegmentService', 'BLIP_DOMAIN', 'ContextProcessorService', 'TenantService', 'PaginationService'];
